module.exports = __webpack_public_path__ + "static/media/Inter-Bold.ab75daca.eot";